const dataGammes = [
  {
    gamme: 'PRIMO',
    children: [
      {
        imageSrc: 'gauge-max-black-32.svg',
        title: 'Internet',
        subTitle: "Jusqu'à 10 Mb/s",
      },
    ],
  },
  {
    gamme: 'ECO',
    children: [
      {
        imageSrc: 'gauge-max-black-32.svg',
        title: 'Internet',
        subTitle: "Jusqu'à 10 Mb/s",
      },
      {
        imageSrc: 'phone-black-32.svg',
        title: 'Téléphonie fixe',
        subTitle: '',
      },
    ],
  },
  {
    gamme: 'TURBO',
    children: [
      {
        imageSrc: 'gauge-max-black-32.svg',
        title: 'Internet',
        subTitle: "Jusqu'à 18 Mb/s",
      },
      {
        imageSrc: 'phone-black-32.svg',
        title: 'Téléphonie fixe',
        subTitle: '',
      },
    ],
  },
  {
    gamme: 'MAX',
    children: [
      {
        imageSrc: 'gauge-max-black-32.svg',
        title: 'Internet',
        subTitle: "Jusqu'à 22 Mb/s",
      },
      {
        imageSrc: 'phone-black-32.svg',
        title: 'Téléphonie fixe',
        subTitle: '',
      },
    ],
  },
  {
    gamme: 'JET',
    children: [
      {
        imageSrc: 'gauge-max-black-32.svg',
        title: 'Internet',
        subTitle: "Jusqu'à 20 Mb/s",
      },
      {
        imageSrc: 'phone-black-32.svg',
        title: 'Téléphonie fixe',
        subTitle: '',
      },
    ],
  },
  {
    gamme: 'TEMPO',
    children: [
      {
        imageSrc: 'gauge-max-black-32.svg',
        title: 'Internet',
        subTitle: "Jusqu'à 20 Mb/s",
      },
    ],
  },
  {
    gamme: 'STAR',
    children: [
      {
        imageSrc: 'gauge-max-black-32.svg',
        title: 'Internet',
        subTitle: "Jusqu'à 20 Mb/s",
      },
      {
        imageSrc: 'phone-black-32.svg',
        title: 'Téléphonie fixe',
        subTitle: '',
      },
    ],
  },
  {
    gamme: 'Alsaway',
    children: [
      {
        imageSrc: 'gauge-max-black-32.svg',
        title: 'Internet',
        subTitle: "Jusqu'à 22 Mb/s",
      },
      {
        imageSrc: 'phone-black-32.svg',
        title: 'Téléphonie fixe',
        subTitle: '',
      },
    ],
  },
  {
    gamme: 'VEGA',
    children: [
      {
        imageSrc: 'gauge-max-black-32.svg',
        title: 'Internet',
        subTitle: "Jusqu'à 20 Mb/s",
      },
      {
        imageSrc: 'phone-black-32.svg',
        title: 'Téléphonie fixe',
        subTitle: '',
      },
    ],
  },

  {
    gamme: 'ozsat',
    children: [
      {
        imageSrc: 'gauge-max-black-32.svg',
        title: 'Internet',
        subTitle: "Jusqu'à 50 Mb/s",
      },
      {
        imageSrc: 'phone-black-32.svg',
        title: 'Téléphonie fixe',
        subTitle: '',
      },
    ],
  },
  {
    gamme: 'NOVA',
    children: [
      {
        imageSrc: 'gauge-max-black-32.svg',
        title: 'Internet',
        subTitle: "Jusqu'à 20 Mb/s",
      },
      {
        imageSrc: 'phone-black-32.svg',
        title: 'Téléphonie fixe',
        subTitle: '',
      },
      {
        imageSrc: 'mobile-signal-out-black-32.svg',
        title: 'Mobile',
        subTitle: '',
      },
    ],
  },
  {
    gamme: 'SIRIUS',
    children: [
      {
        imageSrc: 'gauge-max-black-32.svg',
        title: 'Internet',
        subTitle: "Jusqu'à 22 Mb/s",
      },
      {
        imageSrc: 'phone-black-32.svg',
        title: 'Téléphonie fixe',
        subTitle: '',
      },
    ],
  },
  {
    gamme: 'SUPERNOVA',
    children: [
      {
        imageSrc: 'gauge-max-black-32.svg',
        title: 'Internet',
        subTitle: "Jusqu'à 22 Mb/s",
      },
      {
        imageSrc: 'phone-black-32.svg',
        title: 'Téléphonie fixe',
        subTitle: '',
      },
      {
        imageSrc: 'mobile-signal-out-black-32.svg',
        title: 'Mobile',
        subTitle: '',
      },
    ],
  },
  {
    gamme: 'neosat',
    children: [
      {
        imageSrc: 'gauge-max-black-32.svg',
        title: 'Internet',
        subTitle: "Jusqu'à 100 Mb/s",
      },
      {
        imageSrc: 'phone-black-32.svg',
        title: 'Téléphonie fixe',
        subTitle: '',
      },
      {
        imageSrc: 'mobile-signal-out-black-32.svg',
        title: 'Mobile',
        subTitle: '',
      },
    ],
  },

  {
    gamme: 'MaLigneSat',
    children: [
      {
        imageSrc: 'gauge-max-black-32.svg',
        title: 'Internet',
        subTitle: "Jusqu'à 20 Mb/s",
      },
      {
        imageSrc: 'phone-black-32.svg',
        title: 'Téléphonie fixe',
        subTitle: '',
      },
    ],
  },
  {
    gamme: "Connect'Ecoles",
    children: [
      {
        imageSrc: 'gauge-max-black-32.svg',
        title: 'Internet',
        subTitle: "Jusqu'à 22 Mb/s",
      },
      {
        imageSrc: 'phone-black-32.svg',
        title: 'Téléphonie fixe',
        subTitle: '',
      },
    ],
  },
  {
    gamme: 'RADIO',
    children: [
      {
        imageSrc: 'gauge-max-black-32.svg',
        title: 'Internet',
        subTitle: "Jusqu'à 20 Mb/s",
      },
      {
        imageSrc: 'phone-black-32.svg',
        title: 'Téléphonie fixe',
        subTitle: '',
      },
    ],
  },
  {
    gamme: 'WIMAX',
    children: [
      {
        imageSrc: 'gauge-max-black-32.svg',
        title: 'Internet',
        subTitle: "Jusqu'à 20 Mb/s",
      },
      {
        imageSrc: 'phone-black-32.svg',
        title: 'Téléphonie fixe',
        subTitle: '',
      },
    ],
  },
  {
    gamme: 'WIFIMAX',
    children: [
      {
        imageSrc: 'gauge-max-black-32.svg',
        title: 'Internet',
        subTitle: "Jusqu'à 20 Mb/s",
      },
      {
        imageSrc: 'phone-black-32.svg',
        title: 'Téléphonie fixe',
        subTitle: '',
      },
    ],
  },
  {
    gamme: 'MISTRAL',
    children: [
      {
        imageSrc: 'gauge-max-black-32.svg',
        title: 'Internet',
        subTitle: "Jusqu'à 30 Mb/s",
      },
      {
        imageSrc: 'phone-black-32.svg',
        title: 'Téléphonie fixe',
        subTitle: '',
      },
      {
        imageSrc: 'mobile-signal-out-black-32.svg',
        title: 'Mobile',
        subTitle: '',
      },
    ],
  },
  {
    gamme: 'MISTRAL_PLUS',
    children: [
      {
        imageSrc: 'gauge-max-black-32.svg',
        title: 'Internet',
        subTitle: "Jusqu'à 30 Mb/s",
      },
      {
        imageSrc: 'phone-black-32.svg',
        title: 'Téléphonie fixe',
        subTitle: '',
      },
      {
        imageSrc: 'mobile-signal-out-black-32.svg',
        title: 'Mobile',
        subTitle: '',
      },
    ],
  },
  {
    gamme: 'LASER',
    children: [
      {
        imageSrc: 'gauge-max-black-32.svg',
        title: 'Internet',
        subTitle: "Jusqu'à 1 Gb/s",
      },
      {
        imageSrc: 'phone-black-32.svg',
        title: 'Téléphonie fixe',
        subTitle: '',
      },
      {
        imageSrc: 'mobile-signal-out-black-32.svg',
        title: 'Mobile',
        subTitle: '',
      },
    ],
  },
  {
    gamme: 'LASER_PLUS',
    children: [
      {
        imageSrc: 'gauge-max-black-32.svg',
        title: 'Internet',
        subTitle: "Jusqu'à 1 Gb/s",
      },
      {
        imageSrc: 'phone-black-32.svg',
        title: 'Téléphonie fixe',
        subTitle: '',
      },
      {
        imageSrc: 'mobile-signal-out-black-32.svg',
        title: 'Mobile',
        subTitle: '',
      },
    ],
  },
  {
    gamme: 'WIBOX',
    children: [
      {
        imageSrc: 'gauge-max-black-32.svg',
        title: 'Internet',
        subTitle: "Jusqu'à 1 Gb/s",
      },
      {
        imageSrc: 'phone-black-32.svg',
        title: 'Téléphonie fixe',
        subTitle: '',
      },
    ],
  },
  {
    gamme: '4G',
    children: [
      {
        imageSrc: 'gauge-max-black-32.svg',
        title: 'Internet',
        subTitle: "Jusqu'à 150Mb/s",
      },
      {
        imageSrc: 'phone-black-32.svg',
        title: 'Téléphonie fixe',
        subTitle: '',
      },
    ],
  },
  {
    gamme: 'edison4G',
    children: [
      {
        imageSrc: 'gauge-max-black-32.svg',
        title: 'Internet',
        subTitle: "Jusqu'à 150Mb/s",
      },
      {
        imageSrc: 'phone-black-32.svg',
        title: 'Téléphonie fixe',
        subTitle: '',
      },
      {
        imageSrc: 'mobile-signal-out-black-32.svg',
        title: 'Mobile',
        subTitle: '',
      },
      {
        imageSrc: 'tv-black-32.svg',
        title: 'TV',
        subTitle: '',
      },
    ],
  },
  {
    gamme: 'edisonSat',
    children: [
      {
        imageSrc: 'gauge-max-black-32.svg',
        title: 'Internet',
        subTitle: "Jusqu'à 100 Mb/s",
      },
      {
        imageSrc: 'phone-black-32.svg',
        title: 'Téléphonie fixe',
        subTitle: '',
      },
      {
        imageSrc: 'mobile-signal-out-black-32.svg',
        title: 'Mobile',
        subTitle: '',
      },
      {
        imageSrc: 'tv-black-32.svg',
        title: 'TV',
        subTitle: '',
      },
    ],
  },
  {
    gamme: 'edisonFibre',
    children: [
      {
        imageSrc: 'gauge-max-black-32.svg',
        title: 'Internet',
        subTitle: "Jusqu'à 1 Gb/s",
      },
      {
        imageSrc: 'phone-black-32.svg',
        title: 'Téléphonie fixe',
        subTitle: '',
      },
      {
        imageSrc: 'mobile-signal-out-black-32.svg',
        title: 'Mobile',
        subTitle: '',
      },
      {
        imageSrc: 'tv-black-32.svg',
        title: 'TV',
        subTitle: '',
      },
    ],
  },
  {
    gamme: 'VF',
    children: [
      {
        imageSrc: 'phone-black-32.svg',
        title: 'Téléphonie fixe',
        subTitle: '',
      },
      {
        imageSrc: 'tv-black-32.svg',
        title: 'TV',
        subTitle: '',
      },
    ],
  },
  {
    gamme: 'edison_neosat_plus',
    children: [
      {
        imageSrc: 'gauge-max-black-32.svg',
        title: 'Internet',
        subTitle: "Jusqu'à 200 Mb/s",
      },
      {
        imageSrc: 'phone-black-32.svg',
        title: 'Téléphonie fixe',
        subTitle: '',
      },
      {
        imageSrc: 'mobile-signal-out-black-32.svg',
        title: 'Mobile',
        subTitle: '',
      },
      {
        imageSrc: 'tv-black-32.svg',
        title: 'TV',
        subTitle: '',
      },
    ],
  },
  {
    gamme: 'edison_neosat_plus_pro',
    children: [
      {
        imageSrc: 'gauge-max-black-32.svg',
        title: 'Internet',
        subTitle: "Jusqu'à 200 Mb/s",
      },
      {
        imageSrc: 'phone-black-32.svg',
        title: 'Téléphonie fixe',
        subTitle: '',
      },
    ],
  },
  {
    gamme: 'neosat pro',
    children: [
      {
        imageSrc: 'gauge-max-black-32.svg',
        title: 'Internet',
        subTitle: "Jusqu'à 100 Mb/s",
      },
      {
        imageSrc: 'phone-black-32.svg',
        title: 'Téléphonie fixe',
        subTitle: '',
      },
    ],
  },
];

export default dataGammes;
